import { Link } from 'react-router-dom';
import clsx from 'clsx';

interface VervolgWoBadgeProps {
  /** Klacht-id van het parent-record waarvan dit een vervolg is. */
  klachtId?: string | null;
  /** Klacht-nummer voor weergave (bv. K-1234). */
  klachtNummer?: string | null;
  size?: 'sm' | 'md';
}

/**
 * Groene pill voor vervolg-werkorders. Onderscheidt zich van `KlachtBadge`
 * (rood, klacht zelf) door kleur en label — een vervolg is een oplossing,
 * niet meer hetzelfde probleem. Linkt naar de bovenliggende klacht als
 * `klachtId` bekend is.
 */
export function VervolgWoBadge({ klachtId, klachtNummer, size = 'md' }: VervolgWoBadgeProps) {
  const sizeClasses =
    size === 'sm' ? 'text-[10px] px-1.5 py-0.5 gap-0.5' : 'text-xs px-2 py-0.5 gap-1';
  const className = clsx(
    'inline-flex items-center rounded font-semibold uppercase tracking-wide',
    'bg-emerald-600 text-white hover:bg-emerald-700',
    sizeClasses
  );

  const label = klachtNummer ? `VERVOLG van ${klachtNummer}` : 'VERVOLG';
  const title = klachtNummer
    ? `Vervolg-werkorder van klacht ${klachtNummer}`
    : 'Vervolg-werkorder van een klacht';

  if (!klachtId) {
    return (
      <span className={className} title={title}>
        <span aria-hidden="true">↻</span>
        <span>{label}</span>
      </span>
    );
  }

  return (
    <Link to={`/klachten/${klachtId}`} className={className} title={title}>
      <span aria-hidden="true">↻</span>
      <span>{label}</span>
    </Link>
  );
}
